import { pickUpAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/PickUpAddress";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

pickUpAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        font-family: "MontserratRegular" !important;
        align-items: center;
        background-color: ${getColor("secondary")};
        border-radius: 6px;
        margin-bottom: 5px;
        padding: 10px;
        justify-content: space-between;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-direction: column;
                    gap: 10px;
                    align-items: flex-start;
                    > ${StyledButton} {
                        margin-left: 0;
                        font-size: 14px;
                    }
                `,
                css`
                    flex-direction: column;
                    gap: 10px;
                    align-items: flex-start;
                    > ${StyledButton} {
                        margin-left: 0;
                        font-size: 14px;
                    }
                `,
                css`
                    flex-direction: column;
                    gap: 10px;
                    align-items: flex-start;
                    > ${StyledButton} {
                        margin-left: 0;
                        font-size: 14px;
                    }
                `,
                null,
                null,
            ])}
    `,
};

pickUpAddressStyles.headingText = {
    variant: "h5",
    css: css`
        font-size: 16px;
        font-family: "MontserratRegular";
        color: ${getColor("info")} !important;
        margin-bottom: 0;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: 14px;
                `,
                css`
                    font-size: 14px;
                `,
                css`
                    font-size: 14px;
                `,

                null,
                null,
            ])}
    `,
};
